import { useEffect } from 'react';

export function usePwaInstallationTracking() {
  useEffect(() => {
    const handleAppInstalled = () => {
      localStorage.setItem('isPwaInstalled', 'true');
      if (navigator.onLine) {
        checkPwaInstallationStatus();
      }
    };

    window.addEventListener('appinstalled', handleAppInstalled);
    window.addEventListener('online', checkPwaInstallationStatus);

    return function cleanup() {
      window.removeEventListener('appinstalled', handleAppInstalled);
      window.removeEventListener('online', checkPwaInstallationStatus);
    };
  }, []);
}

function checkPwaInstallationStatus() {
  const isPwaInstalled = localStorage.getItem('isPwaInstalled') === 'true';
  if (!isPwaInstalled) return;

  try {
    window.tap.event('pwa-installation');
    localStorage.removeItem('isPwaInstalled');
  } catch (error) {
    console.error('Error tracking pwa installation:', error);
  }
}
